import { render, staticRenderFns } from "./PricingRuleLabels.vue?vue&type=template&id=5ce233f6&"
import script from "./PricingRuleLabels.vue?vue&type=script&lang=js&"
export * from "./PricingRuleLabels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports